import Icon from "./Icon";
import { IconSizes } from "./types";
export default Icon;
export { IconSizes };